import { apiService } from './api';
import { Table, CreateTableRequest, TableFilters, TableStatus, ApiResponse } from '../types';

export const tableService = {
  async getTables(filters: TableFilters): Promise<Table[]> {
    const response = await apiService.get<Table[]>('/tables', filters);
    return response.data;
  },

  async getTablesByRestaurant(org: string, restaurantId: string, status?: string): Promise<Table[]> {
    const params: any = { org, restaurantId };
    if (status) params.status = status;
    const response = await apiService.get<Table[]>('/tables/by-restaurant', params);
    return response.data;
  },

  async createTable(data: CreateTableRequest): Promise<Table> {
    const response = await apiService.post<Table>('/tables', data);
    return response.data;
  },

  async updateTable(id: string, data: Partial<CreateTableRequest>): Promise<Table> {
    const response = await apiService.put<Table>(`/tables/${id}`, data);
    return response.data;
  },

  async updateTableStatus(id: string, status: TableStatus): Promise<ApiResponse<null>> {
    const response = await apiService.patch<ApiResponse<null>>(`/tables/${id}/status`, { status });
    return response.data;
  },

  async toggleTableStatus(id: string, active: boolean): Promise<ApiResponse<null>> {
    const response = await apiService.patch<ApiResponse<null>>(`/tables/${id}/active?active=`+active);
    return response.data;
  },

  async deleteTable(id: string): Promise<ApiResponse<null>> {
    const response = await apiService.delete<ApiResponse<null>>(`/tables/${id}`);
    return response.data;
  },

  async hardDeleteTable(id: string): Promise<ApiResponse<null>> {
    const response = await apiService.delete<ApiResponse<null>>(`/tables/${id}/hard`);
    return response.data;
  }
};